/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Component Service capability.
 * @export
 */
export const COMPONENT_SERVICE_CAPABILITY_STRINGS = {
  altTitle: `component service`,
  dialogBlurb: `helps developers, editors, and web teams manage content efficiently across multiple sites and customer touchpoints.`,
  dialogBullet1: `Build custom components using modern developer tools.`,
  dialogBullet2: `Use the component library to quickly add content to pages and sites.`,
  dialogBullet3: `Govern content across all customer channels.`,
  subtitle: `Create, share, and reuse components across websites and apps.`,
  title: `Component service`,
};
